import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  standalone: true,
  selector: "app-prefix-knp",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-knp.component.html",
  styleUrl: "./prefix-knp.component.less",
})
export class PrefixKnpComponent extends PrefixTextComponent {
  public constructor() {
    super();
    this.post = false;
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["knp"];
  }
}
